export const getKontoSoll = (record) => {
  return (
    record.soll0 +
    record.soll1 +
    record.soll2 +
    record.soll3 +
    record.soll4 +
    record.soll5 +
    record.soll6 +
    record.soll7 +
    record.soll8 +
    record.soll9 +
    record.soll10 +
    record.soll11 +
    record.soll12
  );
};
export const getKontoHaben = (record) => {
  return (
    record.haben0 +
    record.haben1 +
    record.haben2 +
    record.haben3 +
    record.haben4 +
    record.haben5 +
    record.haben6 +
    record.haben7 +
    record.haben8 +
    record.haben9 +
    record.haben10 +
    record.haben11 +
    record.haben12
  );
};
export const getSaldenArray = (record) => {
  const saldenArray = [];
  saldenArray.push({ soll: record.soll0, haben: record.haben0, index: 0 });
  saldenArray.push({ soll: record.soll1, haben: record.haben1, index: 1 });
  saldenArray.push({ soll: record.soll2, haben: record.haben2, index: 2 });
  saldenArray.push({ soll: record.soll3, haben: record.haben3, index: 3 });
  saldenArray.push({ soll: record.soll4, haben: record.haben4, index: 4 });
  saldenArray.push({ soll: record.soll5, haben: record.haben5, index: 5 });
  saldenArray.push({ soll: record.soll6, haben: record.haben6, index: 6 });
  saldenArray.push({ soll: record.soll7, haben: record.haben7, index: 7 });
  saldenArray.push({ soll: record.soll8, haben: record.haben8, index: 8 });
  saldenArray.push({ soll: record.soll9, haben: record.haben9, index: 9 });
  saldenArray.push({ soll: record.soll10, haben: record.haben10, index: 10 });
  saldenArray.push({ soll: record.soll11, haben: record.haben11, index: 11 });
  saldenArray.push({ soll: record.soll12, haben: record.haben12, index: 12 });

  return saldenArray;
};
export const getKlassenName = (klasse) => {
  switch (parseInt(klasse)) {
    case 10:
      return "Lieferant";
    case 11:
      return "Kunden";
    case 12:
      return "Anlagen";
    default:
      return `${klasse}00`;
  }
};


export const getSaldoSoll=(saldo)=>{
  if (saldo>0)
    return saldo;
  return 0;
}
export const getSaldoHaben=(saldo)=>{
  if (saldo<0)
    return -saldo;
  return 0;
}